module.exports = __webpack_public_path__ + "static/media/bz.fc62fef0.svg";